import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/DeleteOutlineRounded";
import EditIcon from "@material-ui/icons/Edit";

import { Chip } from "@my-scoot/component-library-legacy";
import React from "react";
import { is_desktop, isRequestSuccessful } from "utils/Utils";
import { useStyles } from "./CustomColumns.styles";

import classnames from "classnames";
import { baseApiClient } from "data/modules/api/api.client";
import { logError } from "utils/error";
import { notification_color_keys, useNotifications } from "utils/hooks";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { GET_DISCOUNT_DETAILS } from "features/Discount/constants/Discount.apis";
import {
  COUPON_APPLICABLE_TYPE,
  COUPON_APPLICABLE_TYPE_LABELS,
} from "../discounts.constants";

export const ValidityField = ({ record, showValidityPopup }) => {
  const classes = useStyles({ is_desktop });

  return record["applicability"] == COUPON_APPLICABLE_TYPE.SPECIFIC_LISTINGS ||
    record["applicability"] == COUPON_APPLICABLE_TYPE.LOYALTY_USERS ||
    record["applicability"] == COUPON_APPLICABLE_TYPE.SPECIFIC_COMBOS ? (
    <span
      className={classes.buttonLink}
      onClick={() => showValidityPopup(record.uuid)}
    >
      {COUPON_APPLICABLE_TYPE_LABELS?.[record["applicability"]] ||
        "Specific Offerings"}
    </span>
  ) : (
    COUPON_APPLICABLE_TYPE_LABELS?.[record["applicability"]] || "All Offerings"
  );
};

export const CustomerEligibility = ({ record, showEligibilityPopup }) => {
  const classes = useStyles({ is_desktop });

  return record["applicability"] == 4 ? (
    <span
      className={classes.buttonLink}
      onClick={() => showEligibilityPopup(record.uuid)}
    >
      View Audience
    </span>
  ) : (
    <span>None</span>
  );
};

export const StatusField = ({ record }) => {
  const classes = useStyles();

  return (
    <Chip
      label={record.status}
      chipClassName={classnames(
        classes.chipClassName,
        record.status === "Active"
          ? classes.statusActive
          : classes.statusInActive
      )}
    />
  );
};

export const ActionField = ({
  record,
  setSelectedRecordData,
  setShowDelete,
  setShowDiscountModal,
}) => {
  const classes = useStyles();
  const { notify } = useNotifications();

  const onEdit = async () => {
    try {
      const response = await baseApiClient.get(
        `${GET_DISCOUNT_DETAILS}/${record.uuid}`
      );
      if (isRequestSuccessful(response?.status)) {
        const selectedDiscount = response?.data?.data;
        const selectedrecord = {
          ...selectedDiscount,
          listing_uuids: selectedDiscount?.listings?.map((item) => item.uuid),
        };
        setSelectedRecordData(selectedrecord);
        setShowDiscountModal(true);
      }
    } catch (error) {
      logError({ error });
      notify(
        error?.response?.data?.message ?? SOMETHING_WENT_WRONG,
        notification_color_keys.error
      );
    }
  };

  return (
    <div className={`tw-flex tw-items-center tw-gap-2 tw-pl-2`}>
      <IconButton
        onClick={() => {
          setSelectedRecordData(record);
          setShowDelete(true);
        }}
        className={classes.deleteIcon}
      >
        <DeleteIcon />
      </IconButton>
      <IconButton onClick={onEdit}>
        <EditIcon className={`!tw-fill-[493AB1]`} />
      </IconButton>
    </div>
  );
};
